import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-seguro-card-preco',
  templateUrl: './seguro-card-preco.component.html',
  styleUrls: ['./seguro-card-preco.component.scss']
})
export class SeguroCardPrecoComponent implements OnInit {
  @Input() titulo!: string;
  @Input() imagemUrl!: string;
  @Input() descricao!: string;
  @Input() preco!: string;
  @Input() parcelas!: string;
  @Input() valorCentavo!: string;
  @Input() cotacaoTipo!: string;
  @Input() descCaminhao?: string;
  @Input() isCaminhao: boolean=false;

  @Output() cotacaoOnlineClick = new EventEmitter<string>();

  onCotacaoOnlineClick() {
    this.cotacaoOnlineClick.emit(this.cotacaoTipo);
  }
  constructor() { }

  ngOnInit(): void {
     
  }

}
